import Decimal from 'decimal.js';
import { storeToRefs } from 'pinia';

export default defineNuxtPlugin(() => {
    const { authed } = storeToRefs(useAuthStore());
    return {
        provide: {
            rounded: (value: number) => Math.round(value),
            rounded2: (value: number) => Math.round(value * 100) / 100,
            euroToCent: (value: number | null | undefined) => Math.round((value ?? 0) * 100),
            centToEuro: (value: number | null | undefined) => (value != null ? value / 100 : 0),
            formatCurrencyOrDash: (value: string | null | undefined) => (value == null ? '—' : value),
            priceFromEuros: (euros: number) => euros.toLocaleString(authed.value?.priceLocale || 'fr-BE', { style: 'currency', currency: authed.value?.priceCurrency || 'EUR' }),
            price: (cents: number) => (cents / 100).toLocaleString(authed.value?.priceLocale || 'fr-BE', { style: 'currency', currency: authed.value?.priceCurrency || 'EUR' }),
            priceWithPartialCents: (cents: number | null) => {
                const decimal = new Decimal(cents || 0);
                const euros = decimal.times(10).round().div(1000).toNumber();

                return euros.toLocaleString(authed.value?.priceLocale || 'fr-BE', {
                    style: 'currency',
                    currency: authed.value?.priceCurrency || 'EUR',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 3,
                });
            },
            formatPriceShort: (value: number) => {
                const absValue = Math.abs(value / 100);
                if (absValue < 1000) {
                    return (Math.floor(absValue) === 0 ? '- ' : Math.floor(absValue)) + '€';
                }
                return (absValue / 1000).toFixed(1) + 'k€';
            },
        },
    };
});
